import React, { useState } from "react";
import { useForm, Form } from "../components/controls/useForm";
import Controls from "../components/controls/Controls";
import { Box } from "@mui/material";
import emailjs from "emailjs-com";
import Notification from "../components/controls/Notification";

const initializeFValue = {
  id: 0,
  clientName: "",
  clientEmail: "",
  clientSubject: "",
  clientMessage: "",
};

function ContactForm() {
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "success",
  });

  const validate = (fieldValues = values) => {
    let temp = { ...errors };

    if ("clientEmail" in fieldValues) {
      temp.clientEmail = /$^|.+@.+..+/.test(fieldValues.clientEmail)
        ? ""
        : "Email is not valid.";
    }
    if ("clientMessage" in fieldValues) {
      temp.clientMessage =
        fieldValues.clientMessage.length !== "" &&
        fieldValues.clientMessage.length > 15
          ? ""
          : "Write minimum more than one sentence...";
    }

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };
  //Reuseable Form calling
  const { values, setValues, handleInputChange, resetForm, errors, setErrors } =
    useForm(initializeFValue, true, validate); //if you onchange validation want pass true otherwise pass false
  //After Submit form call
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      //Emailjs Service use send mail to touhidalam649@gmail.com
      emailjs
        .sendForm(
          "service_ghnp43l",
          "template_59hakpl",
          e.target,
          "user_7lxW5JV1VmvLeyXSxEWj3"
        )
        .then(
          (result) => {
            // result.text
            setNotify({
              isOpen: true,
              message: "Mail successfully send :)",
              type: "success",
            });
          },
          (error) => {
            // console.log(error.text);
            setNotify({
              isOpen: true,
              message: "Mail not send ....!",
              type: "warning",
            });
          }
        );
      resetForm();
    }
  };
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Controls.Input
          id="filled-basic"
          label="Name"
          variant="filled"
          name="clientName"
          value={values.clientName}
          onChange={handleInputChange}
        />
        <Controls.Input
          id="filled-basic"
          label="Email"
          variant="filled"
          type="email"
          name="clientEmail"
          required
          value={values.clientEmail}
          onChange={handleInputChange}
          error={errors.clientEmail}
        />
        <Controls.Input
          id="filled-basic"
          label="Subject"
          variant="filled"
          name="clientSubject"
          value={values.clientSubject}
          onChange={handleInputChange}
        />
        <Controls.Input
          id="filled-multiline-static"
          placeholder="Body message..."
          variant="filled"
          label="Body"
          multiline
          rows={4}
          name="clientMessage"
          value={values.clientMessage}
          onChange={handleInputChange}
          error={errors.clientMessage}
        />
        <Box>
          <Controls.Button text="Send Message" type="submit" />
        </Box>
      </Form>
      <Notification notify={notify} setNotify={setNotify} />
    </>
  );
}

export default ContactForm;
